var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgColorWheel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 540 540",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M511.481 205.295c11.906 44.433 11.906 84.977 0 129.41l-24.166 14.637L270 270l220.204-77.9z",
    fill: "#fefe33"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M334.705 28.519c44.432 11.905 79.545 32.177 112.072 64.704l.623 24.873L270 270l43.065-229.492z",
    fill: "#fb9902"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M446.777 93.223c32.527 32.527 52.799 67.64 64.704 112.072L270 270z",
    fill: "#fabc02"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M93.223 93.223c32.527-32.527 67.64-52.799 112.072-64.704l25.91 15.983L270 270 92.74 120.057z",
    fill: "#fe2712"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M205.295 28.519c44.433-11.906 84.977-11.906 129.41 0L270 270z",
    fill: "#fd5308"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M28.519 334.705c-11.906-44.433-11.906-84.977 0-129.41l27.792-18.668L270 270 55.855 349.405z",
    fill: "#8601af"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M28.519 205.295c11.905-44.432 32.177-79.545 64.704-112.072L270 270z",
    fill: "#a7194b"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M205.295 511.481c-44.432-11.905-79.545-32.177-112.072-64.704l2.085-28.188L270 270l-38.955 229.706z",
    fill: "#0247fe"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M93.223 446.777c-32.527-32.527-52.799-67.64-64.704-112.072L270 270z",
    fill: "#3d01a4"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M446.777 446.777c-32.527 32.527-67.64 52.799-112.072 64.704l-24.252-15.093L270 270l176.046 151.157z",
    fill: "#66b032"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M334.705 511.481c-44.433 11.906-84.977 11.906-129.41 0L270 270z",
    fill: "#0391ce"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M511.481 334.705c-11.905 44.432-32.177 79.545-64.704 112.072L270 270l241.481 64.705z",
    fill: "#d0ea2b"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 270,
    cy: 270,
    r: 153.796,
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColorWheel);
export default __webpack_public_path__ + "static/media/color-wheel.2a0e4f819e251ba2189d373b99189943.svg";
export { ForwardRef as ReactComponent };